import { KeyboardEvent } from 'react';

export const preventDecimalInput = (e: KeyboardEvent<HTMLInputElement>) => {
  const charCode = e.charCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) e.preventDefault();
};
